import { noop } from 'lodash';
import { observer } from 'mobx-react';
import { PropTypes } from 'prop-types';
import { useRootStore } from '@nandosaus/state-management';
import React, { useEffect } from 'react';

import { ErrorBoundary } from '../error-boundary';
import { OrderSettingsSummaryCta } from './order-settings-summary-cta';

const OrderSettingsSummary = ({ isCompact, onClick, isModal, disabled, isSticky }) => {
  const { RestaurantStore } = useRootStore();

  useEffect(() => {
    if (!RestaurantStore.loaded && !RestaurantStore.loading) {
      RestaurantStore.loadRestaurants();
    }
  }, [RestaurantStore]);

  return (
    <ErrorBoundary>
      <OrderSettingsSummaryCta
        onClick={onClick}
        isModal={isModal}
        isCompact={isCompact}
        disabled={disabled}
        isSticky={isSticky}
      />
    </ErrorBoundary>
  );
};

OrderSettingsSummary.propTypes = {
  isCompact: PropTypes.bool,
  onClick: PropTypes.func,
  isModal: PropTypes.bool,
  disabled: PropTypes.bool,
  isSticky: PropTypes.bool,
};

OrderSettingsSummary.defaultProps = {
  isCompact: false,
  isModal: false,
  onClick: noop,
  disabled: false,
  isSticky: false,
};

const ComposedOrderSettingSummary = observer(OrderSettingsSummary);
export { ComposedOrderSettingSummary as OrderSettingsSummary };
